import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './styles/multiple-select-options.module.css';
import { Button, Space, Tag } from 'antd';
import { addSelectedOptions, removeSelectedOptions } from '@/store/slices/chatbotInput';
import { connect } from 'react-redux';
import { LeftOutlined, RightOutlined, DownOutlined } from '@ant-design/icons';

const { CheckableTag } = Tag;
export const maxOptions = 5;

const MultipleSelectOptions = ({ block, selectedOptions, addSelectedOptions, removeSelectedOptions }) => {
  const [options, setOptions] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);

  const totalPages = Math.ceil((block?.options?.selectOptions?.length || 0) / maxOptions);

  useEffect(() => {
    paginate(0);
  }, []);

  const paginate = (page) => {
    const allOptions = block?.options?.selectOptions || [];
    const paginatedOptions = totalPages === page + 1
      ? allOptions.slice(page * maxOptions)
      : allOptions.slice(page * maxOptions, (page + 1) * maxOptions);
    setOptions(paginatedOptions);
    setPageNumber(page);
  };

  const handleShowMore = () => {
    setOptions(block?.options?.selectOptions || []);
    setShowMore(true);
  };

  const renderOption = (option, parent) => {
    const isChecked = selectedOptions.some(selected => selected.id === option.id);
    return (
      <CheckableTag
        className={`${isChecked ? styles.checked : styles.not_checked} ${styles.option}`}
        key={option?.id?.toString() + option.title}
        checked={isChecked}
        onChange={(checked) => {
          checked
            ? addSelectedOptions({ ...option, parent_id: parent?.id })
            : removeSelectedOptions(option?.id);
        }}
      >
        {option?.title}
      </CheckableTag>
    );
  };

  const hasMoreOptions = block?.options?.selectOptions?.length > maxOptions;

  return (
    <div className={styles.wrapper}>
      {options.map((option, index) =>
        option?.children ? (
          <div key={index}>
            {option.children.map((item) => renderOption(item, option))}
          </div>
        ) : (
          renderOption(option)
        ),
      )}
      {hasMoreOptions && block?.options?.showMore && !showMore && (
        <p className={styles.option} onClick={handleShowMore}>
          Show More <DownOutlined style={{ fontSize: '10px' }} />
        </p>
      )}
      {hasMoreOptions && !block?.options?.showMore && (
        <div className={styles.pagination_wrapper}>
          <Space size="small" align="center">
            <Button
              type="text"
              size="large"
              disabled={pageNumber === 0}
              onClick={() => paginate(pageNumber - 1)}
              icon={<LeftOutlined style={{ fontSize: 14 }} />}
            />
            <Button
              type="text"
              size="large"
              disabled={pageNumber + 1 === totalPages}
              onClick={() => paginate(pageNumber + 1)}
              icon={<RightOutlined style={{ fontSize: 14 }} />}
            />
          </Space>
        </div>
      )}
    </div>
  );
};

MultipleSelectOptions.propTypes = {
  block: PropTypes.object,
  isActive: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  selectedOptions: state.chatbotInput.selectedOptions,
});

const mapDispatchToProps = {
  addSelectedOptions,
  removeSelectedOptions,
};

export default connect(mapStateToProps, mapDispatchToProps)(MultipleSelectOptions);
